import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft, Wind, PackageCheck } from "lucide-react";
import { MaskedLine } from "./shared";

export default function ThankYou() {
  const [params] = useSearchParams();
  const orderId = params.get("orderId");

  return (
    <div data-testid="thank-you-page" className="relative flex min-h-screen flex-col overflow-hidden bg-ink">
      <div className="spotlight absolute inset-0" aria-hidden="true" />

      <header className="relative z-10 border-b border-steel">
        <div className="mx-auto flex max-w-[1600px] items-center justify-between px-5 py-4 md:px-10">
          <Link to="/" data-testid="thank-you-brand" className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-widest">
            <Wind className="h-5 w-5 text-volt" strokeWidth={2.5} />
            <span>X8<span className="text-volt">/</span>Violent Fan</span>
          </Link>
          <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-smoke">Order status</span>
        </div>
      </header>

      <main className="relative z-10 mx-auto flex w-full max-w-[1600px] flex-1 flex-col justify-center px-5 py-24 md:px-10">
        <div className="flex items-center gap-3 font-mono text-xs tracking-[0.35em] uppercase text-smoke">
          <CheckCircle2 className="h-5 w-5 text-volt" />
          Payment received
        </div>

        <h1 className="mt-8 font-display font-black uppercase leading-[0.9] tracking-tighter">
          <MaskedLine delay={0.1} className="text-[12vw] md:text-[7vw]">You're in.</MaskedLine>
          <MaskedLine delay={0.25} className="text-[12vw] md:text-[7vw]">
            <span className="text-volt">The X8</span> <span className="text-outline">is yours.</span>
          </MaskedLine>
        </h1>

        <div className="mt-10 flex max-w-xl flex-col gap-6">
          {orderId && (
            <div className="flex items-center justify-between border border-steel bg-carbon px-5 py-4 font-mono text-xs" data-testid="order-reference">
              <span className="tracking-[0.25em] uppercase text-smoke">Order reference</span>
              <span className="font-bold text-volt">{orderId}</span>
            </div>
          )}
          <p className="flex items-start gap-3 text-sm leading-relaxed text-smoke md:text-base">
            <PackageCheck className="mt-1 h-5 w-5 shrink-0 text-volt" />
            Your receipt and shipping confirmation are sent by email right away.
            Your X8 ships within 24–48 hours with tracking — keep an eye on your inbox.
          </p>
          <div>
            <Link
              to="/"
              data-testid="back-to-store-button"
              className="group inline-flex items-center gap-3 border border-volt px-8 py-4 font-mono text-sm font-bold tracking-[0.2em] uppercase text-volt transition-colors duration-200 hover:bg-volt hover:text-ink"
            >
              <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
              Back to the X8
            </Link>
          </div>
        </div>
      </main>

      <footer className="relative z-10 border-t border-steel">
        <div className="mx-auto flex max-w-[1600px] items-center justify-between px-5 py-6 md:px-10">
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-smoke">© 2026 X8 / Violent Fan</span>
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-smoke">Secure checkout</span>
        </div>
      </footer>
    </div>
  );
}
